import React from 'react';
import { 
  Monitor, 
  GraduationCap, 
  Plane, 
  ShoppingCart, 
  Truck, 
  Heart, 
  CreditCard, 
  Leaf 
} from 'lucide-react';
import './Industries.css';

const Industries = () => {
  const industries = [
    {
      icon: Monitor,
      name: "Media & Advertising",
      alt: "Media & Advertising"
    },
    {
      icon: GraduationCap,
      name: "Education & EdTech",
      alt: "Education & EdTech"
    },
    {
      icon: Plane,
      name: "Travel & Hospitality",
      alt: "Travel & Hospitality"
    },
    {
      icon: ShoppingCart,
      name: "Retail",
      alt: "Retail"
    },
    {
      icon: Truck,
      name: "Supply Chain & Logistics",
      alt: "Supply Chain & Logistics"
    },
    {
      icon: Heart,
      name: "Healthcare & Life Sciences",
      alt: "Healthcare & Life Sciences"
    },
    {
      icon: CreditCard,
      name: "FinTech",
      alt: "FinTech"
    },
    {
      icon: Leaf,
      name: "Agriculture & Agritech",
      alt: "Agriculture & Agritech"
    }
  ];

  return (
    <section className="industries">
      <div className="container">
        <div className="section-header">
          <h2>Industries we Cater to</h2>
          <h3>Moving with the Times, Moving with You</h3>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => {
            const IconComponent = industry.icon;
            return (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <IconComponent size={48} color="#333333" />
                </div>
                <h4>{industry.name}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries; 